import { Elm } from "../elm/Main.elm";

export function initElm({
  docGeneratorUrl,
  cloverApiUrl,
  keycloakBaseUrl,
  keycloakRealm,
  keycloakClientId,
}) {
  const getRandomInts = (n) => {
    const randInts = new Uint32Array(n);
    crypto.getRandomValues(randInts);
    return Array.from(randInts);
  };

  // For a UUID, we need at least 128 bits of randomness.
  // This means we need to seed our generator with at least 4 32-bit ints.
  // We get 5 here, since the Pcg.Extended generator performs slightly faster if our extension array
  // has a size that is a power of two (4 here).
  const randInts = getRandomInts(5);

  function chooseBackHost(url) {
    let urls = url.split("%");
    const ts = urls.find((a) => {
      const tld = window.location.host
        .split(".")
        .reverse()
        .slice(0, 2)
        .reverse()
        .join(".");
      return a.indexOf(tld) > 1;
    });
    return ts ? ts : urls.length > 1 ? urls[0] : url;
  }

  function rememberedBytes() {
    const bytes = localStorage.getItem("bytes");
    return bytes ? bytes.split(",").map((x) => parseInt(x, 10)) : null;
  }

  const COOKIE_PREFIX = "CLOVER_SESSION="

  function getPiSessionCookie() {
    const value = document.cookie
      .split("; ")
      .find((c) => c.startsWith(COOKIE_PREFIX))
      ?.split("=")[1];
    if (value === undefined) {
      return null;
    }
    return decodeURIComponent(value);
  }

  function setPiSessionCookie([cookieValue, cookieDomain]) {
    // TODO: is it secure?
    document.cookie = COOKIE_PREFIX + cookieValue + "; Path=/; Domain=" + cookieDomain;
  }

  function deletePiSessionCookie() {
    document.cookie = COOKIE_PREFIX + "; Max-Age=-99999999;";
  }

  const flags = {
    docGeneratorHost: chooseBackHost(docGeneratorUrl),
    cloverApiUrl: chooseBackHost(cloverApiUrl),
    seed: randInts[0],
    seedExtension: randInts.slice(1),
    keycloakTempBytes: rememberedBytes(),
    piSession: getPiSessionCookie(),
    keycloakBaseUrl,
    keycloakRealm,
    keycloakClientId,
  };

  var app = Elm.Main.init({
    flags: flags,
  });

  /** gère le click sur les liens du sous module, pour les rendre via pushUrl et non load (évite rechargement page) */
  document.addEventListener("click", function (e) {
    const node = targetOrParentHasHref(e.target);
    const href = node && node.getAttribute("href");
    if (
      href &&
      /^\/.+/.test(href) &&
      !/^\/static/.test(href) &&
      node.getAttribute("target") !== "_blank" &&
      noeIsInSubApp(node)
    ) {
      e.preventDefault();
      app.ports.listenLinkClickedInSubModule.send(href);
    }
  });

  var previousCallback = null;

  app.ports.traceThis.subscribe((s) => console.warn(s));

  app.ports.unloadSubModule.subscribe((_) => {
    if (previousCallback) {
      previousCallback();
      previousCallback = null;
    }
  });

  app.ports.loadSubModule.subscribe(
    ({ route, moduleName, urlToJsFile, flags }) => {
      if (!(window && window[moduleName] && window[moduleName].init)) {
        const subJs = document.createElement("script");
        subJs.setAttribute("src", urlToJsFile);
        document.querySelector("head").appendChild(subJs);

        subJs.addEventListener(
          "load",
          () => {
            handleElmSubApp(
              app,
              route,
              moduleName,
              flags,
              previousCallback
            ).then((c) => (previousCallback = c));
          },
          true
        );
      } else {
        handleElmSubApp(app, route, moduleName, flags, previousCallback).then(
          (c) => (previousCallback = c)
        );
      }
    }
  );

  /* Generate high entropy random bytes using the Web Crypto API and
    remember them so that they are preserved between redirections. This
    allows to protect for XSS & authorization code attacks */
  app.ports.genRandomBytes.subscribe((n) => {
    const buffer = new Uint8Array(n);
    crypto.getRandomValues(buffer);
    const bytes = Array.from(buffer);
    localStorage.setItem("bytes", bytes);
    app.ports.randomBytes.send(bytes);
  });

  app.ports.setPiSessionCookie.subscribe(setPiSessionCookie);

  /*app.ports.sseListen.subscribe( (url) => {
        // TODO forcer le singleton cross tab : pour qu'un même navigateur ne se connecte qu'une fois
        // limitation à 6 connexions en HTTP/1.1
        // zio-http http2 https://github.com/zio/zio-http/issues/186
        // prise sur les connexions dispo pour télécharger les autres contenu
        // prend de la batterie sur un mobile (une connexion TCP à chaque fois)
        // voir
        //  - https://stackoverflow.com/questions/18584525/server-sent-events-and-browser-limits
        //  - https://blog.bitsrc.io/4-ways-to-communicate-across-browser-tabs-in-realtime-e4f5f6cbedca
        //  - ++ BroadcastChannel https://developer.mozilla.org/fr/docs/Web/API/Broadcast_Channel_API
        var evtSource = new EventSource(url, {withCredentials: true})

        evtSource.onopen = () => {
            console.log('listen ...')
        }
        evtSource.addEventListener('ack', (msg) => {
            console.log('ack message', msg)
            app.ports.sseReceive.send(["ack", msg.data])
        })
        evtSource.onerror = function(e) {
            console.error('Receive err', e)
        }
    })*/

  function findSubModule() {
    const contentSelector = ".subAppContainer";
    return document.querySelector(contentSelector);
  }

  function handleElmSubApp(
    parentApp,
    route,
    moduleName,
    flags,
    unsubscribeCallBack
  ) {
    return new Promise((resolve) => {
      const subNode = findSubModule();
      if (subNode) {
        resolve(subNode);
      } else {
        // sometimes subNode is null to let's poll
        const myInterval = setInterval(() => {
          const subNode = findSubModule();
          if (subNode) {
            clearInterval(myInterval);
            resolve(subNode);
          }
        }, 0);
      }
    }).then((subAppNode) => {
      var subApp = window[moduleName].init(
          {
              docGeneratorUrl: docGeneratorUrl,
              keycloakBaseUrl: keycloakBaseUrl,
              keycloakRealm: keycloakRealm,
              keycloakClientId: keycloakClientId,
              startNode: subAppNode
          },
          flags
      );

      function sendLinkClickedFromParentSubscribe({ url }) {
        subApp &&
          subApp.ports &&
          subApp.ports.linkClickedFromParentApp.send(url);
      }
      function displayErrorSubscribe(errors) {
        parentApp.ports.showError.send(errors);
      }
      function loadingEventSubscribe(event) {
        parentApp.ports.loadingEvent.send(event);
      }
      function navigateSubscribe(path) {
        parentApp.ports.listenLinkClickedInSubModule.send(route + path);
      }

      function unsubscribe() {
        subApp.unsubscribe && subApp.unsubscribe();

        parentApp.ports.sendLinkClickedFromParentApp.unsubscribe(
          sendLinkClickedFromParentSubscribe
        );
        if (subApp.ports) {
          return;
        }
        subApp.ports.navigate &&
          subApp.ports.navigate.unsubscribe(navigateSubscribe);
        subApp.ports.displayError &&
          subApp.ports.displayError.unsubscribe(displayErrorSubscribe);
        subApp.ports.loadingEvent &&
          subApp.ports.loadingEvent.unsubscribe(loadingEventSubscribe);
      }

      unsubscribeCallBack && unsubscribeCallBack();

      if (!subApp.ports) {
        return () => {};
      }

      parentApp.ports.sendLinkClickedFromParentApp.subscribe(
        sendLinkClickedFromParentSubscribe
      );

      subApp.ports.navigate &&
        subApp.ports.navigate.subscribe(navigateSubscribe);

      subApp.ports.displayError &&
        subApp.ports.displayError.subscribe(displayErrorSubscribe);

      subApp.ports.loadingEvent &&
        subApp.ports.loadingEvent.subscribe(loadingEventSubscribe);

      return Promise.resolve(unsubscribe);
    });
  }

  /** ne réagir qu'au clique sur les liens <a href .../> */
  function targetOrParentHasHref(node) {
    if (!node || node === document.documentElement) {
      return false;
    }
    if (
      node.hasAttribute("href") &&
      node.nodeName.toLocaleLowerCase() === "a"
    ) {
      return node;
    }
    return targetOrParentHasHref(node.parentNode);
  }
  function noeIsInSubApp(node) {
    if (!node || node === document.documentElement) {
      return false;
    }
    if (node.classList.contains("subApp")) {
      return true;
    }
    return noeIsInSubApp(node.parentNode);
  }

  return app;
}
